// removed by extract-text-webpack-plugin
module.exports = {"header":"styles__header__2yrLz","headerButton":"styles__headerButton__3Wl73","headerIcon":"styles__headerIcon__1uKwn","previewImage":"styles__previewImage__7F66g","shareLinks":"styles__shareLinks__3oi-f"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ViewImage/styles.scss
// module id = 853
// module chunks = 0